export const rubberBand = "cubic-bezier(0.175, 0.885, 0.32, 1.275)";
